import React from 'react'
import { format } from 'date-fns'
import classnames from 'classnames'
import { Button, Dialog, Flex, List, Pane, Popup, Text, Toast, ToggleButton } from '@leverege/ui-elements'
import { connect } from 'react-redux'

import { capitalize } from '@leverege/string-util'
import { ListItem } from '~/views'
import Editor from '../../editors/enums'

import S from './MaintenanceEventGroupScreen.css'
import MaintenanceEventCreateDialog from '../../editors/maintenanceEvents/MaintenanceEventCreateDialog'
import MaintenanceEventEditor from '../../editors/maintenanceEvents/MaintenanceEventEditor'

const DATE_FORMAT_STRING = "EEEE MMMM do 'at' p"

class MaintenanceEventGroupScreen extends React.Component {
  constructor( props ) {
    super( props )

    this.state = {
      active : null,
      showCreate : false,
      toDelete : null
    }
  }

  componentDidMount() {
    const { actions, dispatch } = this.props

    dispatch( actions.list() )
  }

  onCreate = async ( evt ) => {
    const { actions, dispatch } = this.props

    try {
      await dispatch( actions.create( evt.value ) )
      Toast.success( 'Maintenance Event Created Successfully' )
    } catch ( err ) {
      Toast.error( [ 'Failed to create Maintenance Event', err.message ], {} )
      console.error( err )
    }
  }

  onDelete = ( { data } ) => {
    this.setState( { toDelete : data } )
  }

  onConfirmDelete = async () => {
    const { dispatch, itemActions } = this.props
    const { toDelete } = this.state
    try {
      await dispatch( itemActions( toDelete.id ).delete() )
      Toast.success( 'Maintenance Event Successfully Removed', {} )
    } catch ( err ) {
      Toast.error( [ 'Failed to remove maintenance event', err.message ], {} )
      console.error( err )
    }
    this.setState( { toDelete : null, active : null } )
  }

  render() {
    const { maintenanceEvents, itemActions, canCreate = true } = this.props
    const { active, showCreate, toDelete } = this.state

    const itemProps = {
      ...this.props,
      onSelect : this.onSelect,
      onDelete : this.onDelete,
      onClickCard : item => this.setState( { active : active?.value?.type === item?.value?.type ? null : item } )
    }

    const factory = {
      create : ( e ) => {
        return <MaintenanceEventCard event={e} {...itemProps} />
      }
    }

    const editor = <MaintenanceEventEditor id={active?.value?.id} itemActions={itemActions} />
    
    return (
      <Pane className={classnames( S.screen, { [S.active] : active } )}>
        <Pane className={S.cardSection}>
          <Flex className={S.actionHeader} justify="space-between">
            <Text variant="screenTitle">
              Maintenance Events
            </Text>
            <Flex className={S.title} justify="flex-end">
              { canCreate && (
                <Button
                  className={S.new}
                  variant="add"
                  icon="fa fa-fw fa-circle-plus fa-lg"
                  onClick={() => this.setState( { showCreate : true } )}>
                  New Maintenance Event
                </Button>
              )}
            </Flex>
          </Flex>
          <List.Dynamic items={maintenanceEvents} factory={factory} />
          {/* <NotFound filter={filter} filteredList={filteredList} /> */}
        </Pane>
        {active && editor}
        <Dialog.Question
          variant="dialogMedium"
          show={toDelete}
          title="Delete this maintenanceEvent?" // eslint-disable-line max-len
          onOkay={this.onConfirmDelete}
          onCancel={() => this.setState( { toDelete : null } )}
          eventData="Delete"
          okay="Delete maintenance event"
          okayVariant="primaryDestructive" />
        <MaintenanceEventCreateDialog
          onSubmit={this.onCreate}
          show={showCreate}
          eventData="Create"
          onClose={() => this.setState( { showCreate : false } )} />
      </Pane>
    )
  }
}

function MaintenanceEventCard( props ) {
  const { event, onClickCard, onDelete } = props

  return (
    <ListItem
      onEvent={() => onClickCard?.( { data : 'maintenanceEvent', value : event } )}
      item={event}
      title={`${capitalize( event.type )} - ${format( new Date( event.startTime ), DATE_FORMAT_STRING )} to ${format( new Date( event.endTime ), DATE_FORMAT_STRING )}`}
      subtitle={event.description}
      rightView={(
        <Flex justify="flex-end">
          <Popup title={(
            <>
              <i className="fa fa-gear fa-fw"/>
              <i style={{ fontSize : 12 }} className="fa-chevron-down fa fa-fw"/>
            </>
          )}>
            <Popup.Item eventData={event} onClick={onDelete}>Delete</Popup.Item>
          </Popup>
        </Flex>
      )} />
  )
}

export default connect( ( state, ownProps ) => {
  const { actions } = ownProps

  return {
    maintenanceEvents : actions.getMaintenanceEvents( state )
  }
} )( MaintenanceEventGroupScreen )
